
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/the-toolbox/[[...slug]]",
      function () {
        return require("private-next-pages/the-toolbox/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/the-toolbox/[[...slug]]"])
      });
    }
  